// @ts-nocheck
/** @jsxImportSource @emotion/react */
import { Link } from '@mui/material';
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Imgix from 'react-imgix';
import {
  relatedProductsWrapper,
  relatedProductsCard,
  relatedProductsDivider,
  relatedProductsImageWrapper,
  cardWrapper,
  collapseWrapper,
} from './style';
import { basic, plus } from '@shared/cove-data/monitoring';

export default function RelatedProducts({ products, productsToShow }) {
  const customProducts = {
    'video-doorbells': {
      name: 'Video Doorbell Cameras',
      primaryImage: {
        url: 'https://www.datocms-assets.com/10154/1683645950-eufy-and-skybell-doorbell-cameras-edited.png',
      },
    },
    'indoor-camera-eufy': {
      name: 'Eufy Indoor Camera',
      primaryImage: {
        url: 'https://www.datocms-assets.com/10154/1685992948-eufy-indoor-camera-mini.png',
        style: {
          height: '140px',
          width: 'revert',
        },
      },
    },
    'doorbell-cameras': {
      name: 'Doorbell Cameras',
      primaryImage: {
        url: 'https://www.datocms-assets.com/10154/1681335196-doorbell-cameras.png',
        style: {
          height: '140px',
          width: 'revert',
        },
      },
    },
    'outdoor-camera-eufy': {
      name: 'Eufy Outdoor Camera',
      primaryImage: {
        url: 'https://www.datocms-assets.com/10154/1713307108-eufy-outdoor-camera-small.png',
      },
    },
    'doorbell-camera-eufy': {
      name: 'Eufy Doorbell Camera',
      primaryImage: {
        url: 'https://www.datocms-assets.com/10154/1687188884-eufy-doorbell-camera.png',
      },
    },
    'CP-FS-345-1': {
      name: 'Water Leak Detector',
      primaryImage: {
        url: 'https://www.datocms-assets.com/10154/1682975278-flood-sensor.png',
      },
    },
  };

  const [combinedProducts, setCombinedProducts] = useState({});

  useEffect(() => {
    setCombinedProducts({ ...products, ...customProducts });
  }, [products]);
  // `products` is the products list from `useProducts Context`
  // `productsToShow` is an array of objects, with each object having a `sku` and `url` key

  return (
    <div css={relatedProductsWrapper}>
      <h4>Related Products</h4>
      <div css={cardWrapper}>
        {productsToShow.map((p, i) => {
          const product = combinedProducts[p?.sku] || {
            primaryImage: {},
            name: '',
          };
          const { primaryImage, name } = product;
          const imageStyle = primaryImage?.style ?? {};
          return (
            <div key={`related-product-${i}`} css={relatedProductsCard}>
              <Link href={p?.url || ''}>
                <div css={relatedProductsImageWrapper}>
                  {primaryImage?.url && (
                    <Imgix
                      src={`${primaryImage?.url}?auto=format&w=175`}
                      width={175}
                      htmlAttributes={{
                        style: imageStyle,
                        alt: `${name} product`,
                      }}
                    />
                  )}
                </div>
                <span css={relatedProductsDivider}></span>
                {p?.name ? 
                  <p className='text-sm' >{p.name}</p> :
                  <p className='text-sm'>{name}</p>
                }
              </Link>
            </div>
          );
        })}
      </div>
      <div css={collapseWrapper}>
        {productsToShow.map((p, index) => {
          const product = combinedProducts[p?.sku] || {
            primaryImage: {},
            name: '',
          };
          return (
            <div key={`product-${index}-${product?.name}`}>
              <p>{product?.name}</p>
              <a href={p?.url}>View</a>
            </div>
          );
        })}
      </div>
    </div>
  );
}

RelatedProducts.propTypes = {
  products: PropTypes.object,
  productsToShow: PropTypes.arrayOf(PropTypes.object),
};
RelatedProducts.defaultProps = {
  products: {
    'Yi-IC': {
      name: 'YI Indoor Camera',
      sku: 'Yi-IC',
      createdAt: '2019-04-22T19:57:43+01:00',
      pandoId: 106,
      productType: 'equipment',
      price: 59,
      salePrice: 32.45,
      payLaterEligible: false,
      description:
        'Get live or recorded footage of your home sent straight to your phone on the Yi Home App.',
      featureList: [
        {
          description:
            'Need an extra set of eyes inside your home? The YI camera’s got you covered.',
        },
        {
          description: 'Safe Encoding',
        },
        {
          description: 'Ultra wide-angle',
        },
        {
          description: 'High Definition Resolution',
        },
        {
          description: 'Motion Detection',
        },
        {
          description: 'Baby Crying Detection',
        },
      ],
      maximumSensorCountOnSite: 2,
      recommendation:
        'Place one in a central location on your main floor like the\nliving room or kitchen and more if desired in other areas of\nthe home.',
      floorplanImage: {
        url: 'https://www.datocms-assets.com/10154/1556230348-lddyi-indooor-camera-2x-100.jpg',
      },
      primaryImage: {
        url: 'https://www.datocms-assets.com/10154/1558642771-yi-camera-copy.png',
      },
      category: [],
      lowInventoryIcon: false,
      outOfStock: false,
      outOfStockAvailabilityText: '',
      position: 47,
    },
    '2G-GB-345-1': {
      name: 'Glass Break Detector',
      sku: '2G-GB-345-1',
      createdAt: '2019-04-22T19:08:52+01:00',
      pandoId: 5,
      productType: 'equipment',
      price: 35,
      salePrice: 14,
      payLaterEligible: true,
      description:
        'Protecting windows and glass doors has never been easier. Our Glass Break Detectors sense the specific frequency of shattering glass.',
      featureList: [
        {
          description: '5+ year battery life',
        },
        {
          description: '360 degree sensing angle',
        },
        {
          description: 'Customizable options & alerts',
        },
        {
          description: 'Dual shatter recognition',
        },
        {
          description: 'Covers multiple windows',
        },
        {
          description: 'Lifetime warranty available',
        },
        {
          description: '2.6"x2.6"x.8"',
        },
      ],
      maximumSensorCountOnSite: 20,
      recommendation:
        'Place sensors on your wall or ceiling 15 feet from windows or glass doors that need extra protection. ',
      floorplanImage: {
        url: 'https://www.datocms-assets.com/10154/1639506312-glass-break.png',
      },
      primaryImage: {
        url: 'https://www.datocms-assets.com/10154/1628110779-glass-break-detector.png',
      },
      category: [
        {
          name: 'Security Sensors',
          id: '904238',
        },
        {
          name: 'Equipment',
          id: '904233',
        },
        {
          name: 'Burglary and intrusion sensors',
          id: '4760356',
        },
        {
          name: 'RSS',
          id: '142989394',
        },
      ],
      lowInventoryIcon: false,
      outOfStock: false,
      outOfStockAvailabilityText:
        '- Out of Stock - Will Be Available To Order In October',
      position: 7,
      qty: 1,
    },
    'CP-PANEL-345-1': {
      name: 'Cove Touch Alarm Panel',
      sku: 'CP-PANEL-345-1',
      createdAt: '2019-04-22T19:16:17+01:00',
      pandoId: 90,
      productType: 'equipment',
      price: 249,
      salePrice: 99.6,
      payLaterEligible: true,
      description:
        'Our Touchscreen Panel is designed for ease of use. It’s tamperproof, self-testing, and even walks you through the self-installation process. And with the press of a button, you’ll be able to chat with our 24/7 monitoring team whenever you need to. ',
      featureList: [
        {
          description: 'On screen installation guide',
        },
        {
          description: '24 hour backup battery',
        },
        {
          description: 'Two-way voice communication',
        },
        {
          description: '85 dB siren',
        },
        {
          description: 'Smash and grab protection',
        },
        {
          description: 'Lifetime warranty available',
        },
        {
          description: '9"x4.5”x1”',
        },
      ],
      maximumSensorCountOnSite: 1,
      recommendation: 'Place it somewhere easily accessible to the main door.',
      floorplanImage: {
        url: 'https://www.datocms-assets.com/10154/1639507031-touch-screen-panel.png',
      },
      primaryImage: {
        url: 'https://www.datocms-assets.com/10154/1656102814-cove-touch-panel.png',
      },
      category: [
        {
          name: 'Security Sensors',
          id: '904238',
        },
        {
          name: 'Equipment',
          id: '904233',
        },
        {
          name: 'Panels',
          id: '4727863',
        },
        {
          name: 'RSS',
          id: '142989394',
        },
      ],
      lowInventoryIcon: false,
      outOfStock: false,
      outOfStockAvailabilityText: '',
      position: 1,
      qty: 1,
    },
    'CP-KEY-345-1': {
      name: 'Security Key Remote',
      sku: 'CP-KEY-345-1',
      createdAt: '2019-04-22T19:06:22+01:00',
      pandoId: 84,
      productType: 'equipment',
      price: 25,
      salePrice: 10,
      payLaterEligible: true,
      description:
        'Our key remotes enable you to arm and disarm your system in seconds, without having to go to the panel.',
      featureList: [
        {
          description: 'Convenient to use',
        },
        {
          description: '5+ year battery life',
        },
        {
          description: 'Serves as a panic button',
        },
        {
          description: 'Lifetime warranty available',
        },
      ],
      maximumSensorCountOnSite: 18,
      recommendation:
        'Store your keys in a location that will be easy for you to access, but not obvious enough for a burglar to discover.',
      floorplanImage: {
        url: 'https://www.datocms-assets.com/10154/1639506685-key-remote.png',
      },
      primaryImage: {
        url: 'https://www.datocms-assets.com/10154/1640048570-keyremote.png',
      },
      category: [
        {
          name: 'Security Sensors',
          id: '904238',
        },
        {
          name: 'Equipment',
          id: '904233',
        },
        {
          name: 'Remote and Medical Alert ',
          id: '4760361',
        },
        {
          name: 'RSS',
          id: '142989394',
        },
      ],
      lowInventoryIcon: false,
      outOfStock: false,
      outOfStockAvailabilityText: '',
      position: 10,
    },
    '2G-CO-345-1': {
      name: 'Carbon Monoxide Detector',
      sku: '2G-CO-345-1',
      createdAt: '2019-04-22T19:21:01+01:00',
      pandoId: 13,
      productType: 'equipment',
      price: 50,
      salePrice: 25,
      payLaterEligible: true,
      description:
        'Automatically detects carbon monoxide levels in your home before they get dangerous.',
      featureList: [
        {
          description:
            'A must-have for any alarm system. Guards against the gas known as the silent killer.',
        },
        {
          description: 'Extremely simple to install',
        },
        {
          description: '5+ year battery life',
        },
        {
          description: 'Self-testing every 60 minutes',
        },
        {
          description: 'Customizable options & alerts that fit your lifestyle',
        },
        {
          description: 'Compatible with all homes',
        },
        {
          description: 'Lifetime warranty available',
        },
      ],
      maximumSensorCountOnSite: 0,
      recommendation:
        'Place them near bedrooms and utility room to alert you of carbon monoxide gas, particularly while sleeping.',
      floorplanImage: {
        url: 'https://www.datocms-assets.com/10154/1556232077-lddsmoke-heat-freeze-2x-100.jpg',
      },
      primaryImage: {
        url: 'https://www.datocms-assets.com/10154/1558642398-carbon-monoxide-detector-copy.png',
      },
      category: [
        {
          name: 'Equipment',
          id: '904233',
        },
      ],
      lowInventoryIcon: false,
      outOfStock: false,
      outOfStockAvailabilityText: '',
      position: 19,
    },
    '2G-SHF-345-1': {
      name: 'Smoke Detector',
      sku: '2G-SHF-345-1',
      createdAt: '2019-04-22T19:22:23+01:00',
      pandoId: 4,
      productType: 'equipment',
      price: 30,
      salePrice: 15,
      payLaterEligible: true,
      description:
        'Triggers when there’s a fire or if your home\ndrops below freezing temperatures.',
      featureList: [
        {
          description: 'Extremely simple to install',
        },
        {
          description: '5+ year battery life',
        },
        {
          description: 'Self-testing every 60 minutes',
        },
        {
          description: 'Customizable options & alerts',
        },
        {
          description: 'Compatible with any home',
        },
        {
          description: 'Lifetime warranty available',
        },
      ],
      maximumSensorCountOnSite: 0,
      recommendation:
        'Place one in a central location on your main floor and more\nif desired in sleeping areas.',
      floorplanImage: {
        url: 'https://www.datocms-assets.com/10154/1639506543-smoke-heat-freeze.png',
      },
      primaryImage: {
        url: 'https://www.datocms-assets.com/10154/1682975300-smoke-detector.png',
      },
      category: [
        {
          name: 'Equipment',
          id: '904233',
        },
      ],
      lowInventoryIcon: false,
      outOfStock: false,
      outOfStockAvailabilityText: '',
      position: 20,
    },
    'CP-WS-345-1': {
      name: 'Window Sensor',
      sku: 'CP-WS-345-1',
      createdAt: '2019-04-22T19:01:57+01:00',
      pandoId: 82,
      productType: 'equipment',
      price: 15,
      salePrice: 6,
      payLaterEligible: true,
      description:
        'Windows are the second-most common entry points into a home. Let in the light, but not the burglars, with our easy-to-install Window Sensor.',
      featureList: [
        {
          description: 'Simple to install',
        },
        {
          description: '5+ year battery life',
        },
        {
          description: 'Self-testing every 60 minutes',
        },
        {
          description: 'Customizable options & alerts',
        },
        {
          description: 'Compatible with all windows',
        },
        {
          description: 'Lifetime warranty available',
        },
        {
          description: '2.13" x 1.00" x 0.50"',
        },
      ],
      maximumSensorCountOnSite: 40,
      recommendation:
        'We recommend installing these on windows that are easy to access or are out of sight from trafficked areas.',
      floorplanImage: {
        url: 'https://www.datocms-assets.com/10154/1639506176-window-sensor.png',
      },
      primaryImage: {
        url: 'https://www.datocms-assets.com/10154/1642615839-door-window-sensor.png',
      },
      category: [
        {
          name: 'Security Sensors',
          id: '904238',
        },
        {
          name: 'Equipment',
          id: '904233',
        },
        {
          name: 'Burglary and intrusion sensors',
          id: '4760356',
        },
        {
          name: 'RSS',
          id: '142989394',
        },
      ],
      lowInventoryIcon: false,
      outOfStock: false,
      outOfStockAvailabilityText: '',
      position: 5,
    },
    'CP-PIR-345-1': {
      name: 'Motion Detector',
      sku: 'CP-PIR-345-1',
      createdAt: '2019-04-22T19:03:12+01:00',
      pandoId: 83,
      productType: 'equipment',
      price: 30,
      salePrice: 12,
      payLaterEligible: true,
      description:
        'We designed our Motion Detector to fit your lifestyle. It detects human heat signatures and ignores pets. Place one motion detector in a high-traffic area for maximum effectiveness.',
      featureList: [
        {
          description: 'Simple to install',
        },
        {
          description: '5+ year battery life',
        },
        {
          description: 'Self-testing every 60 minutes',
        },
        {
          description: 'Customizable options & alerts',
        },
        {
          description: 'Pet friendly up to 45 lbs',
        },
        {
          description: 'Lifetime warranty available',
        },
        {
          description: '2.85" x 2" x 1.80"',
        },
      ],
      maximumSensorCountOnSite: 20,
      recommendation:
        'We recommend installing these on windows that are easy to access or are out of sight from trafficked areas.',
      floorplanImage: {
        url: 'https://www.datocms-assets.com/10154/1639506256-motion-detector.png',
      },
      primaryImage: {
        url: 'https://www.datocms-assets.com/10154/1642615970-motion-detector_gen2-1.png',
      },
      category: [
        {
          name: 'Security Sensors',
          id: '904238',
        },
        {
          name: 'Equipment',
          id: '904233',
        },
        {
          name: 'Burglary and intrusion sensors',
          id: '4760356',
        },
        {
          name: 'RSS',
          id: '142989394',
        },
      ],
      lowInventoryIcon: false,
      outOfStock: false,
      outOfStockAvailabilityText: '',
      position: 6,
    },
    'CP-DS-345-1': {
      name: 'Door Sensor',
      sku: 'CP-DS-345-1',
      createdAt: '2019-04-18T06:35:59+01:00',
      pandoId: 81,
      productType: 'equipment',
      price: 15,
      salePrice: 6,
      payLaterEligible: true,
      description:
        'Doors are the most common entry points into a home. Our Door Sensors use a magnetic circuit to detect when they open.',
      featureList: [
        {
          description: 'Simple to install',
        },
        {
          description: '5+ year battery life',
        },
        {
          description: 'Self-testing every 60 minutes',
        },
        {
          description: 'Customizable options & alerts',
        },
        {
          description: 'Compatible with all doors',
        },
        {
          description: 'Lifetime warranty available',
        },
        {
          description: '2.13" x 1.00" x 0.50"',
        },
      ],
      maximumSensorCountOnSite: 26,
      recommendation: 'We recommend one for each exterior entry.',
      floorplanImage: {
        url: 'https://www.datocms-assets.com/10154/1639506052-door-sensor.png',
      },
      primaryImage: {
        url: 'https://www.datocms-assets.com/10154/1642615839-door-window-sensor.png',
      },
      category: [
        {
          name: 'Equipment',
          id: '904233',
        },
        {
          name: 'Security Sensors',
          id: '904238',
        },
        {
          name: 'Burglary and intrusion sensors',
          id: '4760356',
        },
        {
          name: 'RSS',
          id: '142989394',
        },
      ],
      lowInventoryIcon: false,
      outOfStock: false,
      outOfStockAvailabilityText: '',
      position: 4,
      qty: 1,
    },
    'CP-FS-345-1': {
      name: 'Flood Sensor',
      sku: 'CP-FS-345-1',
      createdAt: '2019-04-22T19:20:57+01:00',
      pandoId: 88,
      productType: 'equipment',
      price: 20,
      salePrice: 8,
      payLaterEligible: true,
      description:
        'Our Flood Sensor makes it easy to catch leaks before they turn into floods. Once it’s placed, you can rely on it to catch problems early.',
      featureList: [
        {
          description: 'Instant Leak Detection',
        },
        {
          description: 'Self-testing every 60 minutes',
        },
        {
          description: 'Easy to relocate if needed',
        },
        {
          description: 'Customizable options & alerts',
        },
        {
          description: 'Lifetime warranty available',
        },
      ],
      maximumSensorCountOnSite: 40,
      recommendation:
        'Place them under water heaters, sinks, a fridge, near bathtubs, or anywhere there could be a leak. ',
      floorplanImage: {
        url: 'https://www.datocms-assets.com/10154/1639506629-flood-sensor.png',
      },
      primaryImage: {
        url: 'https://www.datocms-assets.com/10154/1628110720-flood-freeze-sensor.png',
      },
      category: [
        {
          name: 'Environment Sensors',
          id: '916451',
        },
        {
          name: 'Equipment',
          id: '904233',
        },
        {
          name: 'RSS',
          id: '142989394',
        },
      ],
      lowInventoryIcon: false,
      outOfStock: false,
      outOfStockAvailabilityText: '',
      position: 9,
    },
    'CP-MED-345-1': {
      name: 'Panic/Medical Button',
      sku: 'CP-MED-345-1',
      createdAt: '2019-04-22T19:01:31+01:00',
      pandoId: 7,
      productType: 'equipment',
      price: 20,
      salePrice: 8,
      payLaterEligible: true,
      description:
        "Cove's Medical Button provides easy access to authorities when you need emergency response services.",
      featureList: [
        {
          description: '5+ year battery life',
        },
        {
          description: 'LED light for alert notification and assured response',
        },
        {
          description: 'Customizable options & alerts',
        },
        {
          description: 'Portable for around the house',
        },
        {
          description: 'Water-proof',
        },
      ],
      maximumSensorCountOnSite: 18,
      recommendation:
        'Put it next to your bed or wear it consistently, depending on your health needs.',
      floorplanImage: {
        url: 'https://www.datocms-assets.com/10154/1639506754-medical-pendant.png',
      },
      primaryImage: {
        url: 'https://www.datocms-assets.com/10154/1640048735-medicalbutton.png',
      },
      category: [
        {
          name: 'Security Sensors',
          id: '904238',
        },
        {
          name: 'Equipment',
          id: '904233',
        },
        {
          name: 'Remote and Medical Alert ',
          id: '4760361',
        },
        {
          name: 'RSS',
          id: '142989394',
        },
      ],
      lowInventoryIcon: false,
      outOfStock: false,
      outOfStockAvailabilityText: '',
      position: 11,
    },
    'window-sticker-sm': {
      name: 'Window Stickers',
      sku: 'window-sticker-sm',
      createdAt: '2019-04-22T19:39:10+01:00',
      pandoId: 200,
      productType: 'equipment',
      price: 0,
      salePrice: 0,
      payLaterEligible: true,
      description: '',
      featureList: [],
      maximumSensorCountOnSite: 3,
      recommendation: '',
      floorplanImage: null,
      primaryImage: {
        url: 'https://www.datocms-assets.com/10154/1576088459-window-sticker-150px.png',
      },
      category: [
        {
          name: 'Yard Sign and Stickers',
          id: '916452',
        },
        {
          name: 'Equipment',
          id: '904233',
        },
      ],
      lowInventoryIcon: false,
      outOfStock: false,
      outOfStockAvailabilityText: '',
      position: 3,
      qty: 3,
    },
    'CP-YS-23i-1': {
      name: 'Yard Sign',
      sku: 'CP-YS-23i-1',
      createdAt: '2019-04-22T20:15:10+01:00',
      pandoId: 11,
      productType: 'equipment',
      price: 0,
      salePrice: 0,
      payLaterEligible: true,
      description: '',
      featureList: [],
      maximumSensorCountOnSite: 1,
      recommendation: '',
      floorplanImage: null,
      primaryImage: {
        url: 'https://www.datocms-assets.com/10154/1556044569-cove-yard-sign-angle01-trans-200px.png',
      },
      category: [
        {
          name: 'Yard Sign and Stickers',
          id: '916452',
        },
        {
          name: 'Equipment',
          id: '904233',
        },
      ],
      lowInventoryIcon: false,
      outOfStock: false,
      outOfStockAvailabilityText: '',
      position: 2,
      qty: 1,
    },
    'CP-SCC01-345-1': {
      name: 'Smoke and Carbon Monoxide Detector',
      sku: 'CP-SCC01-345-1',
      createdAt: '2021-02-09T03:18:27+00:00',
      pandoId: 3,
      productType: 'equipment',
      price: 55,
      salePrice: 22,
      payLaterEligible: true,
      description:
        'Catch fires and carbon monoxide leaks while they are in their infancy. The Smoke/CO detector alerts you and our 24/7 live monitoring agents before small incidents become catastrophes.',
      featureList: [
        {
          description: 'Simple to install',
        },
        {
          description: '5+ year battery life',
        },
        {
          description: 'Self-testing every 60 minutes',
        },
        {
          description: 'Customizable options & alerts',
        },
        {
          description: 'Compatible with any home',
        },
        {
          description: 'Lifetime warranty available',
        },
      ],
      maximumSensorCountOnSite: 6,
      recommendation:
        'Place one in a central location on your main floor and in sleeping areas for added safety. ',
      floorplanImage: {
        url: 'https://www.datocms-assets.com/10154/1639506581-carbon-monoxide.png',
      },
      primaryImage: {
        url: 'https://www.datocms-assets.com/10154/1628110695-smoke-and-co-detector.png',
      },
      category: [
        {
          name: 'Environment Sensors',
          id: '916451',
        },
        {
          name: 'Equipment',
          id: '904233',
        },
        {
          name: 'RSS',
          id: '142989394',
        },
      ],
      lowInventoryIcon: false,
      outOfStock: true,
      outOfStockAvailabilityText: 'Ships in 4-6 weeks',
      position: 8,
    },
    'CP.Y20BA': {
      name: 'Indoor Camera',
      sku: 'CP.Y20BA',
      createdAt: '2021-02-18T20:16:19+00:00',
      pandoId: 108,
      productType: 'equipment',
      price: 99,
      salePrice: 39.6,
      payLaterEligible: false,
      description:
        'An Indoor Camera that’s sleek and easy to use. With two-way communication and free cloud storage, you can watch your feed live, or save clips for later!',
      featureList: [
        {
          description: 'Safe Encoding',
        },
        {
          description: '110° wide-angle lens',
        },
        {
          description: 'High Definition Resolution 1080p',
        },
        {
          description: 'Human Detection',
        },
        {
          description: 'Sound Detection',
        },
      ],
      maximumSensorCountOnSite: 5,
      recommendation:
        'Place one in a central location on your main floor like the living room or kitchen and more if desired in other areas of the home.',
      floorplanImage: {
        url: 'https://www.datocms-assets.com/10154/1639506829-indooor-camera.png',
      },
      primaryImage: {
        url: 'https://www.datocms-assets.com/10154/1634254466-indoor-camerafront.png',
      },
      category: [
        {
          name: 'Cameras',
          id: '904234',
        },
        {
          name: 'Equipment',
          id: '904233',
        },
        {
          name: 'RSS',
          id: '142989394',
        },
      ],
      lowInventoryIcon: false,
      outOfStock: true,
      outOfStockAvailabilityText: 'Ships in 2-3 weeks',
      position: 12,
      qty: 1,
    },
    'pro-setup': {
      name: 'Professional Installation and Setup',
      sku: 'pro-setup',
      createdAt: '2021-05-18T17:11:28+01:00',
      pandoId: null,
      productType: 'addon',
      price: 99,
      salePrice: 99,
      payLaterEligible: true,
      description:
        'Cove is designed so you can install it yourself, but if you’d rather have a professional install it, we provide that option.',
      featureList: [
        {
          description:
            'Starting at just $99, a Cove-approved technician will set up your system for you. You won’t pay until you schedule your appointment so you can easily change your mind and set it up yourself instead. It shouldn’t take more than a few minutes with either option.',
        },
      ],
      maximumSensorCountOnSite: 1,
      recommendation: '',
      floorplanImage: null,
      primaryImage: {
        url: 'https://www.datocms-assets.com/10154/1634764168-professional-installation-icon.svg',
      },
      category: [],
      lowInventoryIcon: false,
      outOfStock: false,
      outOfStockAvailabilityText: '',
      position: 18,
    },
    'SKY.TRIM2.S': {
      name: 'SkyBell Doorbell Camera',
      sku: 'SKY.TRIM2.S',
      createdAt: '2021-07-21T18:53:45+01:00',
      pandoId: null,
      productType: 'equipment',
      price: 189,
      salePrice: 189,
      payLaterEligible: false,
      description:
        'This sleek camera is reliable and easy to use. Keep an eye on your front door and livestream your feed through the Cove app.',
      featureList: [
        {
          description: 'Dimensions: 4.8" x 1.44" x 1.13"; 2 oz',
        },
        {
          description:
            'See everything with 180º horizontal and 120º vertical viewing angel, 1080 HD resolution, and 0.5 LUX color night vision',
        },
        {
          description: 'Connect the camera directly to current doorbell wiring',
        },
        {
          description:
            'Install an adapter to connect to digital doorbell. chimes',
        },
        {
          description: 'Set up and operate via the Cove app',
        },
        {
          description:
            'Talk to your front porch with the 2-way omnidirectional microphone',
        },
        {
          description:
            'Protect your camera from rain, snow, and wind with IP-34 weatherproof rating',
        },
      ],
      maximumSensorCountOnSite: 2,
      recommendation:
        'Must be powered by connecting to existing doorbell wiring. Adapter required for digital door chimes.',
      floorplanImage: null,
      primaryImage: {
        url: 'https://www.datocms-assets.com/10154/1642615796-doorbell-camera-skybell-silver-1.png',
      },
      category: [
        {
          name: 'Cove-Compatible Doorbell Camera',
          id: '64220895',
        },
        {
          name: 'Cameras',
          id: '904234',
        },
        {
          name: 'RSS',
          id: '142989394',
        },
      ],
      lowInventoryIcon: false,
      outOfStock: false,
      outOfStockAvailabilityText: '',
      position: 15,
    },
    'vm-pn': {
      name: 'Cove Plus Monitoring',
      sku: 'vm-pn',
      createdAt: '2019-04-22T20:00:42+01:00',
      pandoId: null,
      productType: 'subscription',
      price: plus.price,
      salePrice: 0,
      payLaterEligible: false,
      description: '',
      featureList: [],
      maximumSensorCountOnSite: 1,
      recommendation: '',
      floorplanImage: null,
      primaryImage: {
        url: 'https://www.datocms-assets.com/10154/1588190056-monitoring.png',
      },
      category: [
        {
          name: 'Monitoring',
          id: '916458',
        },
      ],
      lowInventoryIcon: false,
      outOfStock: false,
      outOfStockAvailabilityText: '',
      position: 48,
      qty: 1,
    },
    'vm-pl': {
      name: 'Cove Plus Monitoring',
      sku: 'vm-pl',
      createdAt: '2019-04-22T19:59:07+01:00',
      pandoId: null,
      productType: 'subscription',
      price: 37.99,
      salePrice: 0,
      payLaterEligible: false,
      description: '',
      featureList: [],
      maximumSensorCountOnSite: 1,
      recommendation: '',
      floorplanImage: null,
      primaryImage: {
        url: 'https://www.datocms-assets.com/10154/1588190037-monitoring.png',
      },
      category: [
        {
          name: 'Monitoring',
          id: '916458',
        },
      ],
      lowInventoryIcon: false,
      outOfStock: false,
      outOfStockAvailabilityText: '',
      position: 49,
    },
    'bm-pl': {
      name: 'Cove Basic Monitoring',
      sku: 'bm-pl',
      createdAt: '2019-04-22T19:59:10+01:00',
      pandoId: null,
      productType: 'subscription',
      price: plus.price,
      salePrice: 0,
      payLaterEligible: false,
      description: '',
      featureList: [],
      maximumSensorCountOnSite: 1,
      recommendation: '',
      floorplanImage: null,
      primaryImage: {
        url: 'https://www.datocms-assets.com/10154/1588190020-monitoring.png',
      },
      category: [
        {
          name: 'Monitoring',
          id: '916458',
        },
      ],
      lowInventoryIcon: false,
      outOfStock: false,
      outOfStockAvailabilityText: '',
      position: 50,
    },
    'bm-pn': {
      name: 'Cove Basic Monitoring',
      sku: 'bm-pn',
      createdAt: '2019-04-22T19:59:45+01:00',
      pandoId: null,
      productType: 'subscription',
      price: basic.price,
      salePrice: 0,
      payLaterEligible: false,
      description: '',
      featureList: [],
      maximumSensorCountOnSite: 1,
      recommendation: '',
      floorplanImage: null,
      primaryImage: {
        url: 'https://www.datocms-assets.com/10154/1588189999-monitoring.png',
      },
      category: [
        {
          name: 'Monitoring',
          id: '916458',
        },
      ],
      lowInventoryIcon: false,
      outOfStock: false,
      outOfStockAvailabilityText: '',
      position: 51,
    },
  },
  productsToShow: [
    { sku: 'CP-DS-345-1', url: '/products/door-sensor/' },
    { sku: 'CP-PIR-345-1', url: '/products/motion-detector/' },
    { sku: 'CP.Y20BA', url: '/products/indoor-camera/' },
  ],
};
